import {ButtonVariant} from './get-shared-button-style';

export type ButtonSize = '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | null;

interface Props {
  padding?: string;
  equalWidth?: boolean;
  variant?: ButtonVariant;
}

export function getButtonSizeStyle(
  size?: ButtonSize,
  {padding, equalWidth, variant}: Props = {}
): string {
  switch (size) {
    case '2xs':
      if (variant === 'link') return 'text-xs';
      return `text-xs h-[1.5rem] ${equalWidth ? 'w-[1.5rem]' : padding || 'px-[0.625rem]'}`;
    case 'xs':
      if (variant === 'link') return 'text-xs';
      return `text-xs h-[1.875rem] ${equalWidth ? 'w-[1.875rem]' : padding || 'px-[0.875rem]'}`;
    case 'sm':
      if (variant === 'link') return 'text-sm';
      return `text-sm h-[2.25rem] ${equalWidth ? 'w-[2.25rem]' : padding || 'px-[1.125rem]'}`;
    case 'md':
      if (variant === 'link') return 'text-base';
      return `text-base h-[2.625rem] ${equalWidth ? 'w-[2.625rem]' : padding || 'px-[1.375rem]'}`;
    case 'lg':
      if (variant === 'link') return 'text-lg';
      return `text-base h-[3.125rem] ${equalWidth ? 'w-[3.125rem]' : padding || 'px-[1.625rem]'}`;
    case 'xl':
      if (variant === 'link') return 'text-xl';
      return `text-lg h-[3.75rem] ${equalWidth ? 'w-[3.75rem]' : padding || 'px-[2rem]'}`;
    default:
      return size || '';
  }
}
